import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { isAuthError } from './lib/session.js';
import { applyTheme, getTheme } from './lib/theme.js';
import { createAppRouter } from './router.js';

applyTheme(getTheme()); // antes do primeiro render: sem piscar o tema errado

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: (count, err) => !isAuthError(err) && count < 2, refetchOnWindowFocus: false },
  },
});
const router = createAppRouter(queryClient);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
